import { createContext, ReactNode, useContext } from 'react';
import {
	useVestingTermsController,
	VestingTermsController,
} from '@dealstack/frontend/shared/components/VestingTerms/hooks/useVestingTermsController';

const VestingTermsContext = createContext<VestingTermsController | null>(null);

export const VestingTermsProvider = ({
	children,
	organizationId,
}: {
	children: ReactNode;
	organizationId?: string;
}) => {
	const controller = useVestingTermsController(organizationId);

	return (
		<VestingTermsContext.Provider value={controller}>{children}</VestingTermsContext.Provider>
	);
};

export const useVestingTermsContext = (): VestingTermsController => {
	const context = useContext(VestingTermsContext);

	if (!context) {
		throw new Error('useVestingTermsContext must be used within a VestingTermsProvider');
	}

	return context;
};
